import React from "react";
import homepageImage from "../assets/img/Homepage.png";
import homepagebanner from "../assets/img/home-banner.png";
import playstore from "../assets/img/app-store.png";
import google from "../assets/img/google-play.png";
import createAccount from "../assets/img/create-account.jpg";
import fundWallet from "../assets/img/fund-wallet.jpg";
import SaveTogether from "../assets/img/Save-Together.png";
import timetograp from "../assets/img/timetograp.png";
import bridgestone from "../assets/img/bridgestone.png";
import alomarlogo1 from "../assets/img/alomarlogo-1.png";
import alomarlogo from "../assets/img/alomarlogo.png";
import eilago from "../assets/img/eilago.png";
import fitness from "../assets/img/fitness.png";
import mouawad from "../assets/img/mouawad.png";
import riyadh from "../assets/img/riyadh.png";
import rosaclara from "../assets/img/rosaclara.png";
import takecontrol from "../assets/img/Take-control.png";
import Newsletter from "./common-components/Newsletter";


const Homepage = () => {
  
  return (
    <>
      <section
        className="relative bg-cover bg-no-repeat lg:pt-[268px] md:pt-secpadding pt-[100px] tab:pb-secpadding pb-40"
        style={{ backgroundImage: `url(${homepageImage})` }}
      >
        <div className="container mx-auto 2xl:max-w-screen-xl flex md:flex-row flex-col-reverse md:items-center lg:gap-12 sm:px-5 px-2">
          {/* Left Text Section */}
          <div className="flex flex-col xl:gap-4 gap-2 lg:pr-10 pr-0 md:w-1/2">
            <div className="flex max-w-max items-center space-x-2 rounded-full  border border-bordercolor px-3 py-2">
              <p className="text-sm font-medium text-blue">NEW</p>
              <p className="text-sm font-medium">
                Partnership signed with Eliago
              </p>
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M8.0876 5L6.9126 6.175L10.7293 10L6.9126 13.825L8.0876 15L13.0876 10L8.0876 5Z"
                    fill="#1F242E"
                  />
                </svg>
              </span>
            </div>
            <h1 className="mb-1 xl:text-[60px] lg:text-[40px] md:text-4xl text-2xl lg:font-extrabold font-bold  xl:leading-[72px] lg:leading-[52px] text-black tracking-[-1px]">
              Save Today, Own Tomorrow — Your Future Starts Here
            </h1>
            <p className="text-base mb-6 pr-16 xl:text-lg">
              Manage your savings with exclusive discounts and cash-backs from
              top brands on every deposit. It’s free, flexible, and no hidden
              fees.
            </p>
            <div className="flex space-x-2">
              <a href="#" className="">
                <img
                  src={playstore}
                  alt="Download on the App Store"
                  className="mr-2 inline w-[144px] h-[48px]"
                />
              </a>
              <a href="#" className="">
                <img
                  src={google}
                  alt="Get it on Google Play"
                  className="mr-2 inline w-[144px] h-[48px]"
                />
              </a>
            </div>
          </div>

          {/* Right Image Section */}
          <div className="md:absolute right-0 mb-10 flex justify-center md:mt-0 md:w-1/2 lg:justify-end">
            <img src={homepagebanner} alt="home-banner" className="size-auto" />
          </div>
        </div>
      </section>
      <section className=" xl:py-secpadding tab:py-96 py-40">
        <div className="mx-auto 2xl:max-w-screen-xl container sm:px-5 px-2 text-center">
          {/* Top Heading */}
          <h3 className="text-lg font-medium text-blue mb-2">
            Save Smart, Earn More
          </h3>
          <h2 className="mb-4 text-2xl font-semibold text-black md:text-4xl">
            Your Money, Your Rules
          </h2>
          <p className="xl:text-lg text-base font-normal xl:mb-[96px] mb-[48px]">
            Simple, rewarding, and flexible—saving has never been easier.
          </p>

          {/* Cards Section */}
          <div className="grid grid-cols-1 md:grid-cols-2 place-items-center tab:grid-cols-3 xl:gap-16 gap-8">
            {/* Card 1 */}
            <div className="border border-[#E9EBF0] rounded-[16px] xl:p-[40px] p-[20px] flex flex-col xl:gap-8 gap-4 items-start">
              <div className="flex items-center justify-center w-12 h-12 bg-blue-100 rounded-[12px]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M20 6.5H17.82C17.93 6.19 18 5.85 18 5.5C18 3.84 16.66 2.5 15 2.5C13.95 2.5 13.04 3.04 12.5 3.85L12 4.52L11.5 3.84C10.96 3.04 10.05 2.5 9 2.5C7.34 2.5 6 3.84 6 5.5C6 5.85 6.07 6.19 6.18 6.5H4C2.89 6.5 2.01 7.39 2.01 8.5L2 19.5C2 20.61 2.89 21.5 4 21.5H20C21.11 21.5 22 20.61 22 19.5V8.5C22 7.39 21.11 6.5 20 6.5ZM15 4.5C15.55 4.5 16 4.95 16 5.5C16 6.05 15.55 6.5 15 6.5C14.45 6.5 14 6.05 14 5.5C14 4.95 14.45 4.5 15 4.5ZM9 4.5C9.55 4.5 10 4.95 10 5.5C10 6.05 9.55 6.5 9 6.5C8.45 6.5 8 6.05 8 5.5C8 4.95 8.45 4.5 9 4.5ZM20 19.5H4V17.5H20V19.5ZM20 14.5H4V8.5H9.08L7 11.33L8.62 12.5L12 7.9L15.38 12.5L17 11.33L14.92 8.5H20V14.5Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-black text-left mb-2">
                  Discounts & Cash-backs
                </h3>
                <p className="text-left">
                  Save smarter by earning exclusive rewards and cash-backs from
                  top brands as you build towards your financial goals.
                </p>
              </div>
              <a
                href="#"
                className="ml-0 inline-flex items-center justify-center text-left font-medium text-blue-100 hover:underline"
              >
                More information
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M8.0876 5L6.9126 6.175L10.7293 10L6.9126 13.825L8.0876 15L13.0876 10L8.0876 5Z"
                    fill="#356ADB"
                  />
                </svg>
              </a>
            </div>

            {/* Card 2 */}
            <div className="border border-[#E9EBF0] rounded-[16px] xl:p-[40px] p-[20px] flex flex-col xl:gap-8 gap-4 items-start">
              <div className="flex items-center justify-center w-12 h-12 bg-blue-100 rounded-[12px]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M19.07 4.93L17.66 6.34C19.1 7.79 20 9.79 20 12C20 16.42 16.42 20 12 20C7.58 20 4 16.42 4 12C4 7.92 7.05 4.56 11 4.07V6.09C8.16 6.57 6 9.03 6 12C6 15.31 8.69 18 12 18C15.31 18 18 15.31 18 12C18 10.34 17.33 8.84 16.24 7.76L14.83 9.17C15.55 9.9 16 10.9 16 12C16 14.21 14.21 16 12 16C9.79 16 8 14.21 8 12C8 10.14 9.28 8.59 11 8.14V10.28C10.4 10.63 10 11.26 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 11.26 13.6 10.62 13 10.28V2H12C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 9.24 20.88 6.74 19.07 4.93Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-black text-left mb-2">
                  Zero Cost, Total Control
                </h3>
                <p className="text-left">
                  Enjoy total control over your savings with no hidden fees or
                  extra charges—what you save is entirely yours to manage.
                </p>
              </div>
              <a
                href="#"
                className="ml-0 inline-flex items-center justify-center text-left font-medium text-blue-100 hover:underline"
              >
                More information
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M8.0876 5L6.9126 6.175L10.7293 10L6.9126 13.825L8.0876 15L13.0876 10L8.0876 5Z"
                    fill="#356ADB"
                  />
                </svg>
              </a>
            </div>

            {/* Card 3 */}
            <div className="border border-[#E9EBF0] rounded-[16px] xl:p-[40px] p-[20px] flex flex-col xl:gap-8 gap-4 items-start">
              <div className="flex items-center justify-center w-12 h-12 bg-blue-100 rounded-[12px]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M18 4H6C3.79 4 2 5.79 2 8V16C2 18.21 3.79 20 6 20H18C20.21 20 22 18.21 22 16V8C22 5.79 20.21 4 18 4ZM16.14 13.77C15.9 13.97 15.57 14.05 15.26 13.97L4.15 11.25C4.45 10.52 5.16 10 6 10H18C18.67 10 19.26 10.34 19.63 10.84L16.14 13.77ZM6 6H18C19.1 6 20 6.9 20 8V8.55C19.41 8.21 18.73 8 18 8H6C5.27 8 4.59 8.21 4 8.55V8C4 6.9 4.9 6 6 6Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-black text-left mb-2">
                  Withdraw Anytime
                </h3>
                <p className="text-left">
                  Your savings are always available whenever you need them.
                  Withdraw without penalties or restrictions, anytime.
                </p>
              </div>
              <a
                href="#"
                className="ml-0 inline-flex items-center justify-center text-left font-medium text-blue-100 hover:underline"
              >
                More information
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M8.0876 5L6.9126 6.175L10.7293 10L6.9126 13.825L8.0876 15L13.0876 10L8.0876 5Z"
                    fill="#356ADB"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className=" xl:py-secpadding tab:py-96 py-40 relative">
        <div className="mx-auto 2xl:max-w-screen-xl container text-left sm:px-5 px-2">
          <div className="flex flex-col md:flex-row items-center">
            {/* Left Side: Image and Content */}
            <div className="w-full md:w-1/2 xl:h-[400px]">
              <div className="md:absolute left-0 top-0 bottom-0  flex justify-center lg:mt-0 md:w-1/2 lg:justify-start">
                <img
                  src={createAccount}
                  alt="create-account"
                  className="size-auto"
                />
              </div>
            </div>

            {/* Right Side: How It Works */}
            <div className="mt-10 w-full lg:mt-0 md:w-1/2 md:pl-10">
              <h3 className="text-lg font-medium text-blue mb-2">
                How it works
              </h3>
              <h2 className="text-2xl tab:text-4xl font-semibold text-black mb-4">
                Create Your Account
              </h2>
              <p className="xl:text-lg text-base font-normal ">
                Getting started is simple. Sign up in just a few clicks, and
                you&apos;re ready to begin your savings journey. No hidden fees,
                no complicated forms—just you and your goals.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className=" xl:py-secpadding tab:py-96 py-40 xl:my-secmargin tab:my-96 md:my-40 my-0 relative">
        <div className="mx-auto 2xl:max-w-screen-xl container text-left sm:px-5 px-2">
          <div className="flex flex-col-reverse md:flex-row items-center md:gap-0 gap-4">
            {/* Left Side: Image and Content */}
            <div className="w-full md:w-1/2 mt-0 lg:mt-0 md:pr-10">
              <h2 className="text-2xl tab:text-4xl font-semibold text-black mb-4">
                Fund Your Wallet, Earn Rewards
              </h2>
              <p className="xl:text-lg text-base font-normal ">
                Top up your wallet with recurring, one-time deposits, or
                round-ups from your linked card. Whether it&apos;s 5 or 500
                riyals, you&apos;re in control—adjust, pause, or speed up
                anytime.
              </p>
            </div>

            {/* Right Side: How It Works */}

            <div className="w-full md:w-1/2 xl:h-[400px]">
              <div className="md:absolute right-0 top-0 bottom-0  flex justify-center lg:mt-0 md:w-1/2 lg:justify-end">
                <img
                  src={fundWallet}
                  alt="create-account"
                  className="size-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className=" xl:py-secpadding tab:py-96 py-40  xl:my-secmargin tab:my-96 md:my-40 my-0 relative">
        <div className="mx-auto 2xl:max-w-screen-xl container text-left sm:px-5 px-2">
          <div className="flex flex-col md:flex-row items-center">
            {/* Left Side: Image and Content */}
            <div className="w-full md:w-1/2 xl:h-[400px]">
              <div className="md:absolute left-0 top-0 bottom-0  flex justify-center lg:mt-0 md:w-1/2 lg:justify-start">
                <img
                  src={SaveTogether}
                  alt="SaveTogether"
                  className="size-auto"
                />
              </div>
            </div>

            {/* Right Side: How It Works */}
            <div className="w-full md:w-1/2 mt-6 lg:mt-0 md:pl-10">
              <h2 className="text-2xl tab:text-4xl font-semibold text-black mb-4">
                Save Together, Reach Goals Faster
              </h2>
              <p className="xl:text-lg text-base font-normal ">
                Let your friends and family pitch in to your brand wallet. They
                can help you get closer to that big purchase or provide a little
                boost when you need it most
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className=" xl:py-secpadding tab:py-96 py-40  relative">
        <div className="mx-auto 2xl:max-w-screen-xl container text-left sm:px-5 px-2">
          <div className="flex flex-col-reverse md:flex-row items-center md:gap-0 gap-6">
            {/* Left Side: Image and Content */}
            <div className="w-full md:w-1/2 mt-0 lg:mt-0 md:pr-10">
              <h2 className="text-2xl tab:text-4xl font-semibold text-black mb-4">
                Time to Grab What’s Yours
              </h2>
              <p className="xl:text-lg text-base font-normal ">
                Once you reach your savings goal, make your purchase just like
                using a debit card—no debt, no hassle. You own it outright, and
                all the credit goes to you!
              </p>
            </div>

            {/* Right Side: How It Works */}

            <div className="w-full md:w-1/2">
              <div className="flex justify-center lg:mt-0 lg:justify-end">
                <img
                  src={timetograp}
                  alt="create-account"
                  className="size-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="tab:py-96 py-40 bg-bggray">
        <div className="mx-auto 2xl:max-w-screen-xl container text-left sm:px-5 px-2 w-100 flex flex-col gap-20">
          <div className="text-center max-w-2xl sm:px-4 px-0 mx-auto flex-1">
            <h2 className="text-2xl tab:text-4xl font-semibold text-black mb-4">
              Boost Your Wallet with Brand Rewards
            </h2>
            <p className="xl:text-lg text-base font-normal ">
              Save with the brands you love and watch your cash rewards grow as
              you get closer to achieving your goals—completely hassle-free!
            </p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 gap-[48px] justify-items-center">
            <img
              src={bridgestone} // Replace with Bridgestone logo
              alt="Bridgestone"
              className="w-auto"
            />
            <img
              src={eilago} // Replace with Eilago logo
              alt="Eilago"
              className="w-auto"
            />
            <img
              src={alomarlogo} // Replace with Alomar logo
              alt="Alomar"
              className="w-auto"
            />
            <img
              src={alomarlogo1} // Replace with Al Sanfat logo
              alt="Al Sanfat"
              className="w-auto"
            />
            <img
              src={mouawad} // Replace with Mouawad logo
              alt="Mouawad"
              className="w-auto"
            />
            <img
              src={rosaclara} // Replace with Rosa Clará logo
              alt="Rosa Clará"
              className="w-auto"
            />
            <img
              src={fitness} // Replace with Fitness Time logo
              alt="Fitness Time"
              className="w-auto"
            />
            <img
              src={riyadh} // Replace with Riyadh Air logo
              alt="Riyadh Air"
              className="w-auto"
            />
          </div>
        </div>
      </section>
      <section className="tab:py-secpadding py-40">
        <div className="mx-auto 2xl:max-w-screen-xl container text-left sm:px-5 px-2">
          <div className="flex flex-col-reverse md:flex-row items-center md:gap-0 gap-6">
            {/* Left Side: Image and Content */}
            <div className="w-full md:w-1/2  lg:mt-0 md:pr-10">
              <h3 className="text-lg font-medium text-blue mb-2">
                Your Savings Count
              </h3>
              <h2 className="text-2xl tab:text-4xl font-semibold text-black mb-4">
                Unlock Your Path to Smart Savings
              </h2>
              <p className="xl:text-lg text-base font-normal ">
                Take control of your future! Save smarter with help from brands
                you love, making your money work harder.
              </p>
              <div className="flex flex-col sm:flex-row items-center tab:mt-[40px] mt-4 tab:gap-4 gap-2">
                <div className="bg-bggray rounded-[16px] tab:py-[32px] py-3 px-4 tab:px-[40px] flex flex-col tab:gap-4 gap-2 w-full">
                  <h3 className="tab:text-5xl text-xl text-black font-bold">
                    +70%
                  </h3>
                  <p className="tab:text-base text-sm">
                    Higher Achievement Rate
                  </p>
                </div>
                <div className="bg-bggray rounded-[16px] tab:py-[32px] py-3 px-4 tab:px-[40px] flex flex-col tab:gap-4 gap-2 w-full">
                  <h3 className="tab:text-5xl text-xl text-black font-bold">
                    2.5X
                  </h3>
                  <p className="tab:text-base text-sm">
                    Greater Financial Security
                  </p>
                </div>
              </div>
            </div>

            {/* Right Side: How It Works */}

            <div className="w-full md:w-1/2">
              <div className="flex justify-center lg:mt-0 lg:justify-end">
                <img
                  src={takecontrol}
                  alt="create-account"
                  className="size-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="tab:py-secpadding py-40">
        <div className="mx-auto 2xl:max-w-screen-xl container text-left sm:px-5 px-2">
          <div className="flex flex-col md:flex-row items-start md:gap-0 gap-6">
            {/* Left Content */}
            <div className="w-full md:w-1/2 mt-0 lg:mt-0 tab:pr-20 md:pr-4">
              <h3 className="text-lg font-medium text-blue mb-2">
                Topup Options
              </h3>
              <h2 className="text-2xl tab:text-4xl font-semibold text-black mb-4">
                Save at Your Own Pace, Your Own Way
              </h2>
              <p className="xl:text-lg text-base font-normal ">
                We’ve made saving simple by giving you multiple ways to fund
                your wallet, so you can pick what works best for you.
              </p>
            </div>

            {/* Right Content */}
            <div className="w-full md:w-1/2 flex flex-col md:gap-12 gap-3">
              {/* Recurring Deposits */}
              <div className="flex items-start space-x-4">
                <div className="relative top-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12.89 11.1049C11.11 10.5149 10.25 10.1449 10.25 9.20488C10.25 8.18488 11.36 7.81488 12.06 7.81488C13.37 7.81488 13.85 8.80488 13.96 9.15488L15.54 8.48488C15.39 8.03488 14.72 6.56488 13 6.24488V5.00488H11V6.26488C8.52 6.82488 8.51 9.12488 8.51 9.22488C8.51 11.4949 10.76 12.1349 11.86 12.5349C13.44 13.0949 14.14 13.6049 14.14 14.5649C14.14 15.6949 13.09 16.1749 12.16 16.1749C10.34 16.1749 9.82 14.3049 9.76 14.0849L8.1 14.7549C8.73 16.9449 10.38 17.5349 11 17.7149V19.0049H13V17.7649C13.4 17.6749 15.9 17.1749 15.9 14.5449C15.9 13.1549 15.29 11.9349 12.89 11.1049ZM3 21.0049H1V15.0049H7V17.0049H4.52C6.13 19.4149 8.88 21.0049 12 21.0049C16.97 21.0049 21 16.9749 21 12.0049H23C23 18.0849 18.08 23.0049 12 23.0049C8.28 23.0049 4.99 21.1549 3 18.3349V21.0049ZM1 12.0049C1 5.92488 5.92 1.00488 12 1.00488C15.72 1.00488 19.01 2.85488 21 5.67488V3.00488H23V9.00488H17V7.00488H19.48C17.87 4.59488 15.12 3.00488 12 3.00488C7.03 3.00488 3 7.03488 3 12.0049H1Z"
                      fill="#474DF4"
                    />
                  </svg>
                </div>
                <div className="flex flex-col gap-3">
                  <h4 className="text-lg font-semibold text-black">
                    Recurring Deposits
                  </h4>
                  <p className="text-gray-600">
                    Set it and forget it! Schedule automatic deposits on a
                    weekly, bi-weekly, or monthly basis. Your savings grow
                    effortlessly while you focus on other things.
                  </p>
                </div>
              </div>

              {/* One-time Deposits */}
              <div className="flex items-start space-x-4">
                <div className="relative top-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12.3902 10.9049C10.1202 10.3149 9.39016 9.70488 9.39016 8.75488C9.39016 7.66488 10.4002 6.90488 12.0902 6.90488C13.8702 6.90488 14.5302 7.75488 14.5902 9.00488H16.8002C16.7302 7.28488 15.6802 5.70488 13.5902 5.19488V3.00488H10.5902V5.16488C8.65016 5.58488 7.09016 6.84488 7.09016 8.77488C7.09016 11.0849 9.00016 12.2349 11.7902 12.9049C14.2902 13.5049 14.7902 14.3849 14.7902 15.3149C14.7902 16.0049 14.3002 17.1049 12.0902 17.1049C10.0302 17.1049 9.22016 16.1849 9.11016 15.0049H6.91016C7.03016 17.1949 8.67016 18.4249 10.5902 18.8349V21.0049H13.5902V18.8549C15.5402 18.4849 17.0902 17.3549 17.0902 15.3049C17.0902 12.4649 14.6602 11.4949 12.3902 10.9049Z"
                      fill="#474DF4"
                    />
                  </svg>
                </div>
                <div className="flex flex-col gap-3">
                  <h4 className="text-lg font-semibold text-black">
                    One-time Deposits
                  </h4>
                  <p className="text-gray-600">
                    Add money whenever it suits you, giving you complete
                    flexibility to save at your own pace.
                  </p>
                </div>
              </div>

              {/* Round-ups Deposits */}
              <div className="flex items-start space-x-4">
                <div className="relative top-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M15 4.00488C10.58 4.00488 7 7.58488 7 12.0049C7 16.4249 10.58 20.0049 15 20.0049C19.42 20.0049 23 16.4249 23 12.0049C23 7.58488 19.42 4.00488 15 4.00488ZM15 18.0049C11.69 18.0049 9 15.3149 9 12.0049C9 8.69488 11.69 6.00488 15 6.00488C18.31 6.00488 21 8.69488 21 12.0049C21 15.3149 18.31 18.0049 15 18.0049Z"
                      fill="#474DF4"
                    />
                    <path
                      d="M3 12.0049C3 9.39488 4.67 7.17488 7 6.35488V4.26488C3.55 5.15488 1 8.27488 1 12.0049C1 15.7349 3.55 18.8549 7 19.7449V17.6549C4.67 16.8349 3 14.6149 3 12.0049Z"
                      fill="#474DF4"
                    />
                  </svg>
                </div>
                <div className="flex flex-col gap-3">
                  <h4 className="text-lg font-semibold text-black">
                    Round-ups Deposits
                  </h4>
                  <p className="text-gray-600">
                    Automatically round up your everyday purchases to the
                    nearest riyal and save the difference.
                  </p>
                </div>
              </div>

              {/* Crowd Savings Deposits */}
              <div className="flex items-start space-x-4">
                <div className="relative top-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M4 16.5049C5.10457 16.5049 6 15.6095 6 14.5049C6 13.4003 5.10457 12.5049 4 12.5049C2.89543 12.5049 2 13.4003 2 14.5049C2 15.6095 2.89543 16.5049 4 16.5049Z"
                      fill="#474DF4"
                    />
                    <path
                      d="M1.22 18.0849C0.48 18.4049 0 19.1249 0 19.9349V21.5049H4.5V19.8949C4.5 19.0649 4.73 18.2849 5.13 17.6049C4.76 17.5449 4.39 17.5049 4 17.5049C3.01 17.5049 2.07 17.7149 1.22 18.0849Z"
                      fill="#474DF4"
                    />
                    <path
                      d="M20 16.5049C21.1046 16.5049 22 15.6095 22 14.5049C22 13.4003 21.1046 12.5049 20 12.5049C18.8954 12.5049 18 13.4003 18 14.5049C18 15.6095 18.8954 16.5049 20 16.5049Z"
                      fill="#474DF4"
                    />
                    <path
                      d="M22.78 18.0849C21.93 17.7149 20.99 17.5049 20 17.5049C19.61 17.5049 19.24 17.5449 18.87 17.6049C19.27 18.2849 19.5 19.0649 19.5 19.8949V21.5049H24V19.9349C24 19.1249 23.52 18.4049 22.78 18.0849Z"
                      fill="#474DF4"
                    />
                    <path
                      d="M16.24 17.1549C15.07 16.6349 13.63 16.2549 12 16.2549C10.37 16.2549 8.93 16.6449 7.76 17.1549C6.68 17.6349 6 18.7149 6 19.8949V21.5049H18V19.8949C18 18.7149 17.32 17.6349 16.24 17.1549Z"
                      fill="#474DF4"
                    />
                    <path
                      d="M9 12.5049C9 14.1649 10.34 15.5049 12 15.5049C13.66 15.5049 15 14.1649 15 12.5049C15 10.8449 13.66 9.50488 12 9.50488C10.34 9.50488 9 10.8449 9 12.5049Z"
                      fill="#474DF4"
                    />
                    <path
                      d="M2.48 11.3649C2.17 10.6049 2 9.86488 2 9.10488C2 6.52488 4.02 4.50488 6.6 4.50488C9.28 4.50488 10.42 6.24488 12 8.09488C13.57 6.26488 14.7 4.50488 17.4 4.50488C19.98 4.50488 22 6.52488 22 9.10488C22 9.86488 21.83 10.6049 21.52 11.3649C22.17 11.6749 22.7 12.1849 23.05 12.8049C23.65 11.6049 24 10.3849 24 9.10488C24 5.40488 21.1 2.50488 17.4 2.50488C15.31 2.50488 13.31 3.47488 12 5.01488C10.69 3.47488 8.69 2.50488 6.6 2.50488C2.9 2.50488 0 5.40488 0 9.10488C0 10.3849 0.35 11.6049 0.96 12.8049C1.31 12.1849 1.84 11.6749 2.48 11.3649Z"
                      fill="#474DF4"
                    />
                  </svg>
                </div>
                <div className="flex flex-col gap-3">
                  <h4 className="text-lg font-semibold text-black">
                    Crowd Savings Deposits
                  </h4>
                  <p className="text-gray-600">
                    Let friends and family contribute directly to your wallet,
                    helping you reach your savings goals faster.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Newsletter/>
    </>
  );
};

export default Homepage;
